export enum StorageType {
	LOCAL_STORAGE = 1,
	SESSION_STORAGE
}
